import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Pagination, BulkDelete } from '../../../v4/components';
import { TableBody, TableHeader } from './tableConfig';
import withLoading from '../../../utils/composition/withLoading';
import { PERMISSION_OBJ } from '../../../data/enums/Permission';
import { dataProps, paginationProps } from '../../../data/enums/Component';
import { crudBulkDeleteRequestConfig } from './config';

const propTypes = {
  data: dataProps.value,
  pagination: paginationProps.value,
  onPageChange: PropTypes.func,
  onCheckBoxClick: PropTypes.func,
  onIconClick: PropTypes.func,
  onBulkDelete: PropTypes.func.isRequired,
  deleteLocationHierarchies: PropTypes.func.isRequired,
  permission: PropTypes.shape({
    read: PropTypes.bool,
    create: PropTypes.bool,
    update: PropTypes.bool,
    delete: PropTypes.bool,
  }),
};

const defaultProps = {
  data: dataProps.defaultValue,
  pagination: paginationProps.defaultValue,
  onPageChange: () => null,
  onCheckBoxClick: () => null,
  onIconClick: () => null,
  permission: PERMISSION_OBJ,
};

const View = ({ ...props }) => {
  const { data, onPageChange, onIconClick, pagination, permission, onBulkDelete, deleteLocationHierarchies } = props;

  return (
    <Fragment>
      <BulkDelete
        data={data.list}
        useExternalAPI
        handler={onBulkDelete}
        deleteServerCall={deleteLocationHierarchies}
        crudExternalRequestConfig={crudBulkDeleteRequestConfig}
        render={(checkedList, primaryCheckboxHandler, secondaryCheckboxHandler) => (
          <div className='table-wrap'>
            <table>
              {TableHeader({
                dataListLength: data.list.length,
                checkedListLength: checkedList.length,
                primaryCheckboxHandler,
                permission,
              })}
              <tbody>
                {data.list.map((level) =>
                  TableBody({
                    data: level,
                    checkedList: checkedList,
                    onIconClick,
                    secondaryCheckboxHandler,
                    permission,
                  }),
                )}
              </tbody>
            </table>
          </div>
        )}
      />
      <Pagination
        currentPage={pagination.page}
        limit={pagination.limit}
        totalItems={data.total}
        onPageChange={onPageChange}
      />
    </Fragment>
  );
};

View.propTypes = propTypes;

View.defaultProps = defaultProps;

const LoginViewWithErrorAndLoading = withLoading(View);

export default LoginViewWithErrorAndLoading;
